const defaultState = [];

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'FAXES_SUMMARY_SUCCESS':
            return action.faxesSummary || defaultState;
        case 'FAXES_SUMMARY_ERROR':
            return [];
        default:
            return state;
    }
}
